import React from 'react';
import { OptionId } from 'openapi';
import { TableCell, FormLabel, Chip, TableRow, Box, CircularProgress } from '@material-ui/core';

interface Props {
    optionItemIds: OptionId[],
    label: string,
    isLoading: Boolean,
    leftRight: number,
    pd: number,
}

export default ((props) => {

    return (
        < TableRow >
            <TableCell>
                <Chip size="small" style={{ color: 'black', backgroundColor: 'lightgray' }} label={props.label} />
            </TableCell>
            <TableCell colSpan={7} key={1} align='left'>
                <Box
                    display="flex"
                    flexWrap="nowrap"
                    bgcolor="background.paper"
                    width="auto"
                >
                    {props.isLoading ? <CircularProgress size={50} thickness={2} /> :
                        props.optionItemIds.map((optionItemId, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <Box mx={0.5}>
                                        <FormLabel id='option' style={{ fontSize: 13, }}>{optionItemId.optionName}</FormLabel>
                                        <br />
                                        <FormLabel id='option' style={{ color: 'black' }}>{optionItemId.optionItemName === "PD" ? props.pd : (optionItemId.optionItemName ? optionItemId.optionItemName : '--')}</FormLabel>
                                        <br />
                                    </Box>
                                </React.Fragment>
                            )
                        })}
                </Box>
            </TableCell>
        </TableRow >
    )
}) as React.FC<Props>;
